<template>
  <div class="pb-0">
    <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow">
      <ListingTable :columnCount="columnLength()" :dataLoading="pageLoading" :rowData="rowData">
        <template v-slot:thead>
          <thead>
            <tr>
              <template v-for="cols in customThead">
                <th v-if="cols.visible" :key="cols.id" class="simple-table-th" :class="{
                  'checkbox-width-limit': cols.checkbox,
                  'pointer-events-none': lodash.isEmpty(rowData),
                }">
                  <template v-if="cols.checkbox && Number(cols.checkbox) == 1">
                    <v-checkbox dense :disabled="pageLoading" v-on:change="selectAll" v-model="checkbox" color="cyan"
                      class="hide-margin" hide-details></v-checkbox>
                  </template>
                  <template v-else>
                    <div v-if="cols.sortable" class="simple-table-text sortable" v-on:click="
                      !pageLoading
                        ? updateSorting({
                          field: cols.field,
                          sort: cols.sort,
                        })
                        : 'javascript:void(0)'
                      ">
                      {{ cols.headerName }}
                    </div>
                    <div v-else class="simple-table-text">
                      {{ cols.headerName }}
                    </div>

                    <template v-if="cols.sort">
                      <v-icon class="simple-table-sort" v-if="cols.sort == 'asc'" small right
                        color="cyan">mdi-sort-ascending</v-icon>
                      <v-icon class="simple-table-sort" v-if="cols.sort == 'desc'" small right
                        color="cyan">mdi-sort-descending</v-icon>
                    </template>
                  </template>
                </th>
              </template>
            </tr>
          </thead>
        </template>
        <template v-slot:tbody>
          <tbody class="custom-border-bottom">
            <template v-if="!lodash.isEmpty(rowData)">
              <tr v-for="(row, index) in rowData" :key="index" link @click="routeToDetail(row)"
                class="customer-listing-row">
                <template v-for="cols in customThead">
                  <td v-if="cols.visible" :key="cols.id" class="font-size-14 font-weight-500" :class="{
                    'simple-table-td': !cols.checkbox,
                    'checkbox-width-limit': cols.checkbox,
                  }">
                    <template v-if="cols.checkbox && Number(cols.checkbox) == 1">
                      <v-checkbox dense v-model="selectedRows" v-bind:value="Number(row.id)"
                        v-on:change="unSeletedRow(row.id)" :disabled="row.status == 3" color="cyan" class="hide-margin"
                        hide-details></v-checkbox>
                    </template>
                    <template v-else-if="cols.field == 'barcode'">
                      <v-chip label dense small color="chip-custom-blue" outlined
                        class="font-weight-600 custom-barcode">{{ row.barcode }}
                      </v-chip>
                    </template>
                    <template v-else-if="cols.field == 'staff'">
                      <div class="job-listing-customer">
                        <p class="m-0 custom-nowrap-ellipsis-two-line">
                          <b v-if="row && row.staff">{{
                            row.staff.display_name
                          }}</b>
                        </p>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'leave_type'">
                      <div class="job-listing-customer">
                        <p class="m-0 custom-nowrap-ellipsis-two-line">
                          <b v-if="row && row.leave_types">{{
                            row.leave_types.charAt(0).toUpperCase() +
                            row.leave_types.slice(1)
                          }}</b>
                          <em class="text-muted" v-else>
                            no leave type </em>
                        </p>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'dates'">
                      <div class="d-flex">
                        <b class="font-weight-700">
                          Start Date :
                        </b>
                        <template v-if="row?.engineer_leave?.length">
                          <b>
                            {{ formatDate(row.engineer_leave[0]?.leave_date) }}
                          </b>
                        </template>
                        <em class="text-muted" v-else>no start date</em>
                      </div>
                      <div class="d-flex">
                        <b class="d-inline-block font-weight-700">
                          End Date:
                        </b>
                        <template v-if="row?.engineer_leave?.length">
                          <b>
                            <template v-if="row.engineer_leave.length > 1">
                              - {{ formatDate(row?.engineer_leave[row.engineer_leave?.length - 1]?.leave_date) }}
                            </template>
                            <template v-else>
                              {{ formatDate(row.engineer_leave[0]?.leave_date) }}
                            </template>
                          </b>
                        </template>
                        <em class="text-muted" v-else>no end date</em>
                      </div>
                    </template>

                    <template v-else-if="cols.field == 'category'">
                      <div class="job-listing-customer">
                        <p class="m-0" v-if="row && row.category">
                          <v-chip
                            class="mx-2 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                            color="blue darken-1" label small text-color="white">
                            {{ row.category.replace("-", " ") }}
                          </v-chip>
                        </p>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'dates'">
                      <div class="job-listing-customer leave-dates-responsive" v-if="row && row.start_date">
                        <div class="leave-date-row">
                          <b class="d-inline-block font-weight-700">Start:</b>
                          <span v-if="row.start_date">
                            {{ formatDate(row.start_date) }}
                          </span>
                          <em class="text-muted" v-else> no start date </em>
                        </div>
                        <div class="leave-date-row">
                          <b class="d-inline-block font-weight-700">End:</b>
                          <span v-if="row.end_date">
                            {{ formatDate(row.end_date) }}
                          </span>
                          <em class="text-muted" v-else> no end date </em>
                        </div>
                      </div>
                    </template>

                    <!-- <template v-else-if="cols.field == 'half_day'">
                      <template v-if="row && row.duration">
                        <div class="d-flex align-center flex-wrap leave-halfday-responsive">
                          <div class="halfday-block">
                            <b class="d-inline-block font-weight-700">Second:</b>
                            <span v-if="row.second_half_start_date == '1'">
                              {{ formatDate(row.start_date) }}
                            </span>
                            <em class="text-muted" v-else>not provided</em>
                          </div>
                          <div class="halfday-block">
                            <b class="d-inline-block font-weight-700">First:</b>
                            <span v-if="row.first_half_of_end_date == '1'">
                              {{ formatDate(row.end_date) }}
                            </span>
                            <em class="text-muted" v-else>not provided</em>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <em class="text-muted">no half day</em>
                      </template>
                    </template> -->

                    <template v-else-if="cols.field == 'total_leave_days'">
                      <div style="max-width: fit-content" class="mt-1">
                        <span class="mb-2">
                          <v-avatar color="green" size="27">
                            <span class="white--text fw-600">
                              {{ row.engineer_leave_count > 0 ? row.engineer_leave_count : 0 }}</span>
                          </v-avatar>
                        </span>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'reason'">
                      <div style="width: 150px" v-if="row && row.reason" @click.stop>
                        <read-more class="custom-read-more font-weight-600 font-size-18 custom-gray-color"
                          style="display: block" more-str="read more" :text="row.reason || '<em>No Reason</em>'"
                          link="#" less-str="read less" :max-chars="25" />
                      </div>
                      <em class="text-muted" v-else> no reason </em>
                    </template>
                    <template v-else-if="cols.field == 'status'">
                      <span @click.stop>
                        <span @click="updateStatus('delete', row)"><v-icon style="font-size: 22px" color="red" >mdi-delete</v-icon></span>
                      </span>
                    </template>

                    <template v-else-if="cols.field == 'added_at'">
                      <TableActivity v-if="!lodash.isEmpty(row.added_by)" :data="row">
                        <template v-slot:display_name>
                          {{ row.added_by?.display_name }}
                        </template>
                        <template v-slot:date_time>
                          <template v-if="getDateCountAll(row.added_at)">{{
                            row.created_at
                          }}</template>
                          <template v-else>{{
                            formatDateTime(row.added_at)
                          }}</template>
                        </template>
                        <template v-slot:format_date_time>
                          {{ formatDate(row.added_at) }}
                          {{ formatDateStartTime(row.added_at) }}
                        </template>
                      </TableActivity>
                    </template>
                  </td>
                </template>
              </tr>
            </template>
            <tr v-else-if="!pageLoading">
              <td :colspan="10" class="py-4">
                <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                  <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                  Uhh... There are no leaves at the moment.
                </p>
              </td>
            </tr>
          </tbody>
        </template>
      </ListingTable>
    </perfect-scrollbar>
    <ListingFooter :dataLoading="pageLoading" :showingFrom="showingFrom" :showingTo="showingTo" :totalRows="totalRows"
      :currentPage="currentPage" :totalPages="totalPages"></ListingFooter>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { LeaveApplyEventBus } from "@/core/lib/leave.from.lib.js";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import { mapGetters } from "vuex";
import { GET_LEAVE_STATUS } from "@/core/services/store/leave.module";
import JwtService from "@/core/services/jwt.service";
import { JobEventBus } from "@/core/lib/job/job.lib";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "Leave-listing-template",
  mixins: [CommonMixin],
  props: {
    autoRefresh: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    getLeaveFilter: {
      deep: true,
      immediate: true,
      handler(param) {
        this.getLeaves(param);
      },
    },
    autoRefresh: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.getLeaves(this.getLeaveFilter);
        }
      },
    },
  },
  components: {
    /*  Barcode, */
    TableActivity,
    ListingFooter,
    ListingTable,
  },
  data() {
    return {
      CurrentUser: JwtService.currentUser(),

      totalRows: 0,
      rowsOffset: 0,
      currentPage: 1,
      totalPages: 0,
      checkbox: false,
      defaultColDefs: [],
      defaultColShow: [],
      statusDropdown: [
        {
          text: "Cancelled",
          value: "cancelled",
          color: "teal",
          headercolor: "primary",
          status: "1",
        },
      ],
      customThead: [],
      selectedRows: [],
      perPage: 15,
      pageLoading: false,
      statusList: [],
      rowData: [],
      filter_search: null,
      filter_status: null,
      timeout: null,
      timeoutLimit: 500,
    };
  },
  mounted() {
  },
  methods: {
    columnLength() {
      const defaultColDefs = this.lodash.filter(this.defaultColDefs, {
        visible: true,
      });
      if (defaultColDefs) {
        return defaultColDefs.length;
      }
      return 0;
    },

    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    routeToDetail(row) {
      if (this.isDeleted) {
        return false;
      }

      this.$router.push({
        name: "admin.leave.detail",
        params: { id: row.id },
      });
    },
    updateStatus(status, row) {
      this.$emit("leave-details", { barcode: row.barcode, leaveId: row.id });
      this.$emit("status-data", status);
      this.$emit("status-dialog", true);
      this.$store.dispatch(GET_LEAVE_STATUS, {});
    },
    getLeaves(filter = {}) {
      const _this = this;

      if (_this.pageLoading) {
        return false;
      }

      if (filter && filter.dates && filter.dates.length === 2) {
        if (moment(filter.dates[0]).isAfter(filter.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError({ message: "End Date must be after Start Date." })
          );
          return false;
        }
      }

      _this.rowData = [];
      _this.pageLoading = true;

      let current_page = _this.currentPage;
      let per_page = _this.perPage;

      _this
        .getLeaveList({ filter, current_page, per_page })
        .then((data) => {
          _this.rowData = data.rows;
          _this.statusList = data.status_list;
          _this.totalPages = Math.ceil(data.total_rows / data.per_page);
          _this.currentPage = data.current_page;
          let thead = data.theads;
          _this.defaultColDefs = data.theads;
          _this.totalRows = data.total_rows;
          _this.customThead = [];
          for (let index = 0; index < thead.length; index++) {
            let element = thead[index];
            if (element.visible == 1) {
              _this.customThead.push(element);
            }
          }
          let t_out = this.lodash.filter(
            thead,
            (row) => Number(row.visible) == 1
          );
          _this.defaultColShow = this.lodash.map(t_out, "field");
          _this.rowsOffset = data.offset;
        })
        .catch((error) => {
          _this.logError(error);
          ErrorEventBus.$emit(
            "update:error",
            InitializeError({ message: "Something went wrong." })
          );
        })
        .finally(async () => {
          _this.pageLoading = false;
        });
    },

    getLeaveList(data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "leave",
              data,
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    selectAll() {
      this.selectedRows = [];
      if (this.checkbox) {
        for (let i = 0; i < this.rowData.length; i++) {
          if (this.rowData[i].status != 3) {
            this.selectedRows.push(this.rowData[i].id);
          }
        }
      }
    },
    unSeletedRow(checkbox) {
      console.log(checkbox);
    },
    getOverdue(row) {
      if (row.status == 1 && moment(row.start_date).isBefore(moment(), "day")) {
        return true;
      }
      return false;
    },
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.rowData) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      let rowData = this.lodash.map(this.rowData, function (row) {
        if (!row.header) return row;
      });

      rowData = this.lodash.without(rowData, undefined);

      return this.rowsOffset + (rowData ? rowData.length : 0);
    },
    ...mapGetters(["getLeaveFilter", "getLeaveStatus"]),
  },

  beforeDestroy() {
    JobEventBus.$emit("show:visit", true);
    PaginationEventBus.$off("update:pagination");
    PaginationEventBus.$off("update:per-page");
    LeaveApplyEventBus.$off("refresh-headers");
  },
  created() {
    const _this = this;

    if (this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page);
    }

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.currentPage = param;
      _this.getLeaves(_this.getLeaveFilter);
    });

    LeaveApplyEventBus.$on("refresh-headers", (neasasw) => {
      this.customThead = neasasw;
    });
  },
};
</script>

<style scoped>
.leave-dates-responsive,
.leave-halfday-responsive {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  min-width: 120px;
  max-width: 100%;
}

.leave-date-row,
.halfday-block {
  flex: 1 1 120px;
  min-width: 120px;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
}

.label {
  width: auto;
  min-width: 60px;
  margin-right: 4px;
}

@media (max-width: 900px) {

  .leave-dates-responsive,
  .leave-halfday-responsive {
    flex-direction: column;
    gap: 4px;
  }

  .leave-date-row,
  .halfday-block {
    min-width: 0;
    width: 100%;
    flex: 1 1 100%;
  }

  .label {
    min-width: 50px;
    font-size: 13px;
  }
}

@media (max-width: 600px) {

  .leave-dates-responsive,
  .leave-halfday-responsive {
    font-size: 12px;
    gap: 2px;
  }

  .label {
    min-width: 40px;
    font-size: 12px;
  }
}
</style>
